import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchWfAttendanceProfile } from "../Moduels/attendance/wfApi";
import { queryClient } from "../lib/queryClient";
import { orgScope } from "../services/orgScope";

/**
 * Shift Management is always available under Attendance (master + allocation).
 * Work-schedule gating applies on the page actions, not sidebar visibility.
 * The profile read is shared so Sidebar and Settings do not each call it.
 */
export function useAttendanceShiftNav() {
  const scope = orgScope();
  useQuery({
    queryKey: ["wf-attendance-profile", scope],
    queryFn: fetchWfAttendanceProfile,
    staleTime: 60_000,
    retry: 1,
    enabled: scope !== "anonymous",
  });

  useEffect(() => {
    const load = () => {
      queryClient.invalidateQueries({ queryKey: ["wf-attendance-profile", scope] });
    };
    window.addEventListener("attendance-profile-changed", load);
    return () => {
      window.removeEventListener("attendance-profile-changed", load);
    };
  }, [scope]);

  return true;
}
